import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Button } from "@mui/material";
import { tokens } from "../../../theme";
import { DateOnlyFormatter } from "../../../helpers/formatters";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../api/main/appStore";
import ModalDecisionContent from "../../shared/modal/ModalDecisionContent";
import { InvestmentTenureModel } from "../../../api/models/investmentTenure";
import CreateOrUpdateInvestmentTenure from "../investmentTenures/CreateOrUpdateInvestmentTenure";

interface Props {
  data: InvestmentTenureModel[];
}

const columns = ["Tenure", "Last Modified", " "];

export default observer(function InvestmentTenureTable({ data }: Props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const colors = tokens();
  const { commonStore, investmentTenureStore } = useStore();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleUpdateInvestmentTenureClick = (
    investmentTenure: InvestmentTenureModel
  ) =>
    commonStore.setModalContent(
      <CreateOrUpdateInvestmentTenure investmentTenure={investmentTenure} />,
      ""
    );

  const handleDeleteInvestmentTenureClick = (
    investmentTenure: InvestmentTenureModel
  ) =>
    commonStore.setModalContent(
      <ModalDecisionContent
        actionName={`delete ${investmentTenure.tenure} days`}
        actionCallback={() =>
          investmentTenureStore.deleteInvestmentTenure(investmentTenure.id)
        }
      />,
      ""
    );

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                "& .MuiTableCell-head": {
                  color: `${colors.grey[600]}`,
                  fontWeight: "bolder",
                },
              }}
            >
              {columns.map((column, index) => (
                <TableCell key={index} align="left" style={{ minWidth: 170 }}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell
                      sx={{
                        py: 0,
                      }}
                    >
                      {row.tenure} days
                    </TableCell>
                    <TableCell>{DateOnlyFormatter(row.dateModified)}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        color="primary"
                        onClick={() => handleUpdateInvestmentTenureClick(row)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        color="error"
                        onClick={() => handleDeleteInvestmentTenureClick(row)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
});
